import React from 'react';
import { ButtonConfig, ButtonState } from '../utils/bancaButtonUtils';
import { BsGear, BsArrowLeftRight, BsCheckCircleFill } from 'react-icons/bs';

interface ActionButtonProps {
  config: ButtonConfig;
  onClick?: () => void;
  customIcon?: React.ReactNode;
  customTitle?: string;
  customStyle?: React.CSSProperties;
  showText?: boolean;
  checkSize?: string;
}

const ActionButton: React.FC<ActionButtonProps> = ({ config, onClick, customIcon, customTitle, customStyle, showText = false, checkSize = '10px' }) => {


  if (config.state === ButtonState.HIDDEN) {
    return null;
  }

  const getButtonStyle = () => {
    const isDisabled = config.state === ButtonState.DISABLED || config.title.includes('DISABLED');
    const baseStyle = {
      border: '1px solid #ccc',
      borderRadius: '3px',
      padding: '4px 6px',
      fontSize: '12px',
      backgroundColor: isDisabled ? '#e9ecef' : config.backgroundColor,
      color: 'black'
    };

    switch (config.state) {
      case ButtonState.ENABLED:
      case ButtonState.SUCCESS:
      case ButtonState.WARNING:
        return { ...baseStyle, cursor: isDisabled ? 'not-allowed' : 'pointer', opacity: isDisabled ? 0.6 : 1 };
      case ButtonState.DISABLED:
        return { ...baseStyle, cursor: 'not-allowed', opacity: 0.6 };
      default:
        return baseStyle;
    }
  };

  return (
    <div style={{ position: 'relative', display: customStyle?.width ? 'block' : 'inline-block' }}>
      <button
        style={{...getButtonStyle(), ...customStyle}}
        onClick={config.state !== ButtonState.DISABLED && !config.title.includes('DISABLED') ? onClick : undefined}
        disabled={config.state === ButtonState.DISABLED || config.title.includes('DISABLED')}
        title={customTitle || config.title}
      >
        {customIcon ? (
          <>
            {showText && customTitle}
            {customIcon}
          </>
        ) : (config.icon === 'BsGear + BsArrowLeftRight + BsGear' ? (
          <span style={{ display: 'flex', alignItems: 'center', gap: '1px' }}>
            <BsGear style={{ color: 'black', fontSize: '10px' }} />
            <BsArrowLeftRight style={{ color: 'black', fontSize: '8px' }} />
            <BsGear style={{ color: 'black', fontSize: '10px' }} />
          </span>
        ) : (
          config.icon
        ))}
      </button>
      {(config.state === ButtonState.SUCCESS || config.state === ButtonState.WARNING) && (
        <BsCheckCircleFill 
          style={{
            position: 'absolute',
            top: '-2px',
            right: '-2px',
            color: config.state === ButtonState.SUCCESS ? '#198754' : '#ffc107',
            backgroundColor: 'white',
            borderRadius: '50%',
            fontSize: checkSize,
            zIndex: 1
          }}
        />
      )}
    </div>
  );
};

export default ActionButton;